function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "arrows down arrow");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Liste-des-remarques",
  transform: "translate(-400.000000, -128.000000)",
  fill: "#5B5B5B",
  fillRule: "nonzero",
  stroke: "#979797",
  strokeWidth: 0.714285714
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15",
  transform: "translate(280.000000, 115.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(60.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrows-down-arrow",
  transform: "translate(64.500000, 9.000000) rotate(-90.000000) translate(-64.500000, -9.000000) translate(59.500000, 5.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.84363037,6.91550164 C4.88321247,6.9690006 4.94029402,7 4.9998755,7 C5.05945697,7 5.11653853,6.9690006 5.15612062,6.91550164 L9.94763782,0.415627506 C10.0238854,0.31212951 10.015969,0.15463256 9.92972171,0.0626343415 C9.84430771,-0.0283638963 9.71181184,-0.0193640706 9.63556422,0.0841339252 L4.9998755,6.37301214 L0.364603433,0.0846339155 C0.288355812,-0.0188640802 0.156276599,-0.0283638963 0.0704459433,0.0631343319 C-0.0158013661,0.15463256 -0.0241344395,0.3126295 0.0525298355,0.416127496 L4.84363037,6.91550164 Z",
  id: "Shape"
}))))));

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "12px",
    viewBox: "0 0 9 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow.f8998924.svg";
export { ForwardRef as ReactComponent };